(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rooted-flower-calendar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rooted-flower-calendar')) {
  customElements.define('rooted-flower-calendar', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.buttons = Array.from(this.querySelectorAll('[data-month-button]'));
      this.panels = Array.from(this.querySelectorAll('[data-month]'));
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.showMonth(button.dataset.monthButton));
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.buttons.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            this.buttons[next].focus();
            this.showMonth(this.buttons[next].dataset.monthButton);
          }
        });
      });
      this.showMonth(this.dataset.initial || this.buttons[0]?.dataset.monthButton);
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-month]');
        if (panel) this.showMonth(panel.dataset.month);
      });
    }
    showMonth(month) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.monthButton === month)));
      this.panels.forEach(panel => panel.hidden = panel.dataset.month !== month);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
